<template>
  <div id="app">
    <router-view></router-view>
    <!-- <div class="app-footer">
      <van-row><span class="footer-mod"></span>
        <a class="link"
          href="http://www.beian.gov.cn/portal/registerSystemInfo?spm=a21bo.jianhua.1997523009.38.5af911d9j2IF1S&recordcode=33010002000078">浙公网安备
          33010002000078号</a>
      </van-row>
      <a class="link">京ICP证030173号</a>
    </div> -->
  </div>
</template>

<script>

// 用于测试环境调试使用 正式环境需要屏蔽
// import VConsole from 'vconsole/dist/vconsole.min.js'
export default {
  name: 'App',
  created() {
    // let vConsole = new VConsole()
  },
  mounted() {
    window.onload = function () {
      document.addEventListener('touchstart', function (event) {
        if (event.touches.length > 1) {
          event.preventDefault()
        }
      })
      document.addEventListener('gesturestart', function (event) {
        event.preventDefault()
      })
    }
  }
}
</script>

<style lang="less">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

.app-footer {
  text-align: center;
  padding-bottom: 50px;
  background-color: #eee;

  .footer-mod {
    background-position: -861px 0px;
    width: 20px;
    height: 20px;
    background-image: url(https://img.alicdn.com/tfs/TB1EPnIQXXXXXaSXpXXXXXXXXXX-1133-35.jpg);
    display: inline-block;
    vertical-align: middle;
    margin-right: 5px;
  }

  .link {
    cursor: pointer;
    font-weight: 500;
    font-size: 14px;
    color: #909399;
    margin-right: 10px;
    display: -webkit-inline-box;
    display: -ms-inline-flexbox;
    display: inline-flex;
    -webkit-box-orient: horizontal;
    -webkit-box-direction: normal;
    -ms-flex-direction: row;
    flex-direction: row;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    vertical-align: middle;
    position: relative;
    text-decoration: none;
    outline: 0;
    padding: 0;
    background-color: transparent;
  }
}
</style>
